import React, { useState, useEffect } from "react";
import * as tools_api from "../../services/api/tools";
import SelectBase from "./SelectBase";

const SelectMaterial: React.FC<SelectType<MaterialValue>> = props => {
  const [items, setItems] = useState<MaterialValue[]>([]);

  useEffect(() => {
    getItems();
  }, []);

  const getItems = () => {
    tools_api.getMaterials().then(({ data }) => setItems(data));
  };

  const options = () => {
    return items
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(item => ({
        value: item.id,
        label: item.name
      }));
  };

  return (
    <SelectBase
      {...props}
      placeholder="Material..."
      newItem={props.newItem}
      updatedItem={props.updatedItem}
      deletedItem={props.deletedItem}
      onClick={props.onChange}
      getItems={getItems}
      options={options()}
    />
  );
};

export default SelectMaterial;
